export default {
	refreshQuery(opts = {}) {
		let query = this.app.query;
		for (let i in query) {
			if (!query.hasOwnProperty(i)) continue;
			if (query[i] === '' || query[i] == null) {
				delete query[i];
			}
		}

		let hash = opts.keepHash ? this.app.hash : null;

		this.navigate({ query, hash });
	},
	navigate(opts, isReplace = false) {
		let query = opts.query || {};

		let route = { ...opts, query };

		let method = isReplace ? 'replace' : 'push';
		this.$router[method](route).catch(err => {
			if (err.name !== 'NavigationDuplicated') {
				throw err;
			}
		});
	},
	getExtendedQueryUrl(query, path = null) {
		let newQuery = {...this.app.query, ...query};
		let obj = {query: newQuery};
		if (path) {
			obj.path = path;
		}
		return obj;
	},
	editQueryParams(params, isReplace = false) {
		let query = {...this.app.query, ...params};
		this.navigate({query}, isReplace);
	},
	input(opts) {
		return new Promise(resolve => {
			this.app.dialogData = opts;
			this.app.dialogData.text = this.app.dialogData.text || '';
			this.app.dialogData.resolve = resolve;
			this.app.dialogShown = true;
		});
	},
	alert(text = '', title = null) {
		let type = 'alert';
		let cancelVal = null;
		if (title === null) {
			title = this.ii('MESSAGE');
		}
		return this.input({type, text, title, cancelVal});
	},
	confirm(text = '', title = null) {
		let type = 'confirm';
		let cancelVal = false;
		if (title === null) {
			title = this.ii('CONFIRMATION');
		}
		return this.input({type, text, title, cancelVal});
	},
	prompt(text = '', val = '', title = null) {
		let type = 'text';
		let cancelVal = null;
		if (title === null) {
			title = this.ii('INPUT');
		}
		return this.input({type, text, title, val, cancelVal});
	},
	ii(origKey, defaultVal = null) {
		if (!this.app || !this.app.loadedLang || !origKey) return '';

		let key = origKey.toUpperCase().replace(/[\s-]/g, '_').replace(/[()]/g, '');
		if (defaultVal === null) {
			defaultVal = key;
		}
		return this.app.langMessages[this.app.loadedLang][key] || this.app.langMessages.en[key] || defaultVal;
	},
	iiArgs(key, ...params) {
		let text = this.ii(key);
		if (!text) return text;

		text = text.replace(/@(\d+)/g, (m, num) => {
			return params[num - 1];
		});
		return text;
	},
	getLanguageByCode(code) {
		return this.ii('LANG_' + code, '');
	},
	getCountryByCode(code) {
		return this.ii('GEO_' + code, '');
	},
	getGeoItems() {
		if (!this.geoMap) return [];
		let items = Object.keys(this.geoMap).map(code => {
			let country = this.geoMap[code];
			let localeCountry = this.getCountryByCode(code) || country;
			let searchVal = code + '*' + country + (localeCountry !== country ? '*' + localeCountry : '');
			if (code === 'GB') {
				searchVal += '*UK*Great Britain';
			} else if (code === 'GR') {
				searchVal += '*EL';
			} else if (code === 'US') {
				searchVal += '*USA*United states of America';
			} else if (code === 'NL') {
				searchVal += '*Holland';
			} else if (code === 'RU') {
				searchVal += '*Russian Federation';
			} else if (code === 'AE') {
				searchVal += '*UAE';
			}

			let item = {
				key: code,
				val: localeCountry,
				sVal: searchVal,
				sortVal: country,
				flag: code
			};
			return item;
		});
		return items;
	},
	getLangItems() {
		let items = Object.keys(this.langMap).map(code => {
			let lang = this.langMap[code];
			let localeLang = this.getLanguageByCode(code) || lang;
			let searchVal = code + '*' + lang + (localeLang !== lang ? '*' + localeLang : '');

			let item = {
				key: code,
				val: localeLang,
				sVal: searchVal,
				sortVal: lang
			};
			return item;
		});
		items.unshift({key: '_', val: '?'});
		return items;
	},
	getFilterItems() {
		return Object.values(this.filtersMap);
	},
	arrayToListItems(arr, i18n = false) {
		return (arr || []).map(it => {
			let key = it, val = it;
			if (i18n) {
				val = this.ii(val);
			}
			if (!it) {
				key = '_';
				val = '?';
			}
			return {key, val};
		})
	},
	getDefaultDateRange() {
		let start = moment();
		if (this.$route.name !== 'dashboard') {
			start = start.add(-7, 'day');
		}
		let startDate = start.format('YYYY-MM-DD');
		let endDate = moment().format('YYYY-MM-DD');
		return [startDate, endDate];
	},
	parseDateRange(val, defaultType = 'default') {
		let format = 'days';
		let from, to;
		if (val) {
			if (val.indexOf('_') !== -1) {
				[from, to] = val.split('_');
			} else if (/^\d\d\d\d-\d\d$/.test(val)) {
				format = 'month';
				from = val + '-01';
				to = val + '-' + moment.tz(val, this.app.tz).daysInMonth();
			}
		} else if (defaultType === 'default') {
			[from, to] = this.getDefaultDateRange();
		} else {
			console.warn('Unknown default date-range type: ' + defaultType);
		}

		return { from, to, format };
	},
	checkFeature(feature) {
		return this.app.user && this.app.user.features.indexOf(feature) !== -1;
	}
};